import styled from 'styled-components';

export const OverlayWrapper = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: ${({ theme }) => theme.width.full};
  height: ${({ theme }) => theme.width.full};
  background: rgba(31, 31, 31, 0.9);
  z-index: 1002;
`;
